module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_8019.1f5649d5.png";